<template>
  <div>
    <el-dialog
      ref="matchQuestionnaireDialog"
      v-dialogDrag
      title="微信群成员匹配问卷用户"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogMatchForm"
        :model="dialogMatchForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="微信号">
                  <el-input
                    v-model="dialogViewForm.userName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="昵称">
                  <el-input
                    v-model="dialogViewForm.nickname"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="类型">
                  <el-input
                    v-model="dialogViewForm.typeValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所在群">
                  <el-input
                    v-model="dialogViewForm.groupNames"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="零售户所在区域">
                  <el-input
                    v-model="dialogViewForm.storeArea"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="零售户档案门店名称">
                  <el-input
                    v-model="dialogViewForm.certificatedStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="零售户档案专卖证号">
                  <el-input
                    v-model="dialogViewForm.storeCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="零售户档案状态">
                  <el-input
                    v-model="dialogViewForm.storeStatusValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="睿零售用户名称">
                  <el-input
                    v-model="dialogViewForm.appUserName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="睿零售用户电话">
                  <el-input
                    v-model="dialogViewForm.appUserPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="睿零售用户门店名称">
                  <el-input
                    v-model="dialogViewForm.appUserStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="睿零售用户专卖证号">
                  <el-input
                    v-model="dialogViewForm.appUserCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            调研问卷用户清单
          </h3>
          <div class="modal-row-box">
            <el-table
              :data="questionnaireUserDataList"
              border
              stripe
              :header-cell-style="{background:theme()}"
              style="width: 100%; margin: 5px 0;"
              height="305"
              class="member-match-table"
            >
              <el-table-column
                label="选择"
                align="center"
                width="55"
              >
                <template slot-scope="scope">
                  <el-radio
                    v-model="currentRow"
                    :label="scope.$index"
                    @change.native="getCurrentRow(scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-for="(column, index) in memberTableColumns"
                :key="index"
                resizable
                show-overflow-tooltip
                :width="column.width ? column.width : ''"
                :label="column.label"
                :prop="column.prop"
                :align="column.align || ''"
                header-align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row[column.prop] }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          匹配
        </el-button>
        <el-button
          type="warning"
          @click="handleExclude"
        >
          排除
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 微信联系人API
import { viewWeChatContactApi, matchQuestionnaireUserApi, excludeQuestionnaireUserApi } from '@/api/v2/weChatContact'
// 调研问卷参与人员API
import { listSurveyQuestionnaireUserDataApi } from '@/api/v2/surveyQuestionnaireDetail'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
    questionnaireUserIds: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogViewForm: {},
      dialogMatchForm: {},
      dialogExcludeForm: {},

      memberTableColumns: [
        { label: '问卷用户标识', prop: 'uid', width: 240 },
        { label: '昵称', prop: 'nickname', width: 150 },
        { label: '市场', prop: 'market', width: 150 },
        { label: '专卖证号', prop: 'certificateNo', width: 150 },
        { label: '门店名称', prop: 'storeName', width: 150 },
        { label: '本香门店码绑定电话', prop: 'bxPhone', width: 150 },
        { label: '档位', prop: 'level', width: 70 },
      ],
      questionnaireUserDataList: [],
      currentRow: null,
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogViewForm = {};
        _this.dialogMatchForm = {
          id: _this.dataId,
          questionnaireUserId: 0
        }
        _this.dialogExcludeForm = {
          id: _this.dataId,
          questionnaireUserIds: _this.questionnaireUserIds
        }
        _this.questionnaireUserDataList = [];
        _this.currentRow = null;

        _this.loadChatContactData();
        _this.loadQuestionnaireUserData();

        _this.$nextTick(() => {
          _this.$refs.dialogMatchForm.clearValidate()
        })
      }
    }
  },
  methods: {
    theme () {
      return '#0076ff'
    },
    // 加载数据
    loadChatContactData () {
      let _this = this;
      viewWeChatContactApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogViewForm = data;
      })
    },
    // 根据问卷用户ID集合获取问卷用户清单
    loadQuestionnaireUserData () {
      let _this = this;
      if (_this.questionnaireUserIds) {
        listSurveyQuestionnaireUserDataApi({ userIds: _this.questionnaireUserIds }).then((response) => {
          const { data } = response
          _this.questionnaireUserDataList = data || [];
        })
      }

    },
    getCurrentRow (row) {
      let _this = this;
      _this.dialogMatchForm.questionnaireUserId = row.id;
    },
    // 保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogMatchForm.validate(valid => {
        if (valid) {
          _this.$confirm('是否确认匹配选择的问卷参与用户?', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            matchQuestionnaireUserApi(_this.dialogMatchForm).then(() => {
              _this.$message({ message: '匹配成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    // 排除
    handleExclude () {
      let _this = this;
      _this.$confirm('是否确认排除选择的问卷参与用户?', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        excludeQuestionnaireUserApi(_this.dialogExcludeForm).then(() => {
          _this.$message({ message: '排除成功', type: 'success' })
          _this.$emit('reloadData')
          _this.modalClose()
        }).catch(() => { })
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
  }
}

.member-match-table {
  // radio label隐藏不显示
  ::v-deep .el-radio__label {
    display: none;
  }
}
</style>
